import {
  calculateColumnWidth,
  mapColumnTypes,
  TYPES,
} from "@/react/components/table";
import { getColumnDef } from "@/react/schema";

import CountCell from "./cells/CountCell";
import schema, { JobNames, JobSources, Statuses } from "./schema";

const COUNT_CELL_SIZE = 180;

const getCountCellDef = (schemaPath, columnHeader) => ({
  ...getColumnDef(schemaPath, columnHeader),
  customCell: CountCell,
  size: COUNT_CELL_SIZE,
});

const columnDefinition = () =>
  calculateColumnWidth([
    {
      ...getColumnDef(schema.fields.jobId, "Job ID"),
      type: TYPES.STRING,
    },
    {
      ...getColumnDef(schema.fields.customerId, "Customer ID"),
      type: TYPES.STRING,
    },
    {
      ...getColumnDef(schema.fields.details, "Details"),
      type: TYPES.STRING,
    },
    {
      ...getColumnDef(schema.fields.userId, "User ID"),
      type: TYPES.STRING,
    },
    {
      ...getColumnDef(schema.fields.action, "Action"),
      type: TYPES.SELECT,
      options: Object.values(JobNames).map((jobName) => jobName),
    },
    {
      ...getColumnDef(schema.fields.status, "Status"),
      type: TYPES.SELECT,
      options: Object.values(Statuses).map((status) => status),
    },
    {
      ...getColumnDef(schema.fields.source, "Source"),
      type: TYPES.SELECT,
      options: Object.values(JobSources).map((source) => source),
    },
    getCountCellDef(schema.fields.stats.fields.successes, "Successes"),
    getCountCellDef(schema.fields.stats.fields.failures, "Failures"),
    {
      ...getColumnDef(schema.fields.createdAt, "Created At"),
      type: TYPES.STRING,
    },
    {
      ...getColumnDef(schema.fields.updatedAt, "Updated At"),
      type: TYPES.STRING,
    },
    {
      ...getColumnDef(schema.fields.completedAt, "Completed At"),
      type: TYPES.STRING,
    },
  ]).map(mapColumnTypes);

export default columnDefinition;
